// Polish role help texts; same shape as the nb/en/sv blocks in companyUserRolesRoleHelp.js.
export const GENERIC_ACTION_PL = {
  "read": {
    "includes": "Dostęp do odczytu danych objętych tą rolą w ramach włączonego modułu.",
    "adminNote": "Użytkownik może widzieć dane innych osób (klientów, projekty, raporty itp.). Oceń potrzebę wglądu i wewnętrzne zasady ochrony danych osobowych."
  },
  "create": {
    "includes": "Może tworzyć nowe wpisy (zlecenia, godziny, dokumenty itp.) w module.",
    "adminNote": "Upewnij się, że szablony i pola obowiązkowe są skonfigurowane, aby nowe wpisy były spójne i kompletne."
  },
  "update": {
    "includes": "Może zmieniać istniejące wpisy w zakresie, na który pozwala rola.",
    "adminNote": "Zmiany mogą wpływać na finanse, BHP i to, co widzi klient. Ogranicz rolę do osób, które faktycznie mają poprawiać błędy."
  },
  "delete": {
    "includes": "Może usuwać lub archiwizować treści tam, gdzie system na to pozwala.",
    "adminNote": "Usunięcie może być nieodwracalne lub wpłynąć na identyfikowalność. Tylko dla zaufanych użytkowników z jasno określoną odpowiedzialnością."
  },
  "approve": {
    "includes": "Może zatwierdzać (np. godziny, dokumenty, zamówienia), gdy wymaga tego proces.",
    "adminNote": "Zatwierdzenie często blokuje wpisy dla innych. Rozdziel odpowiedzialność tak, aby zawsze był zastępca zatwierdzającego."
  },
  "reject": {
    "includes": "Może odrzucać lub zwracać wpisy wymagające rozpatrzenia.",
    "adminNote": "Odrzucenie wpływa na innych użytkowników i terminy. Zadbaj, aby odbiorca otrzymał jasną informację (powiadomienie/proces)."
  }
};

export const BY_ROLE_PL = {
  "admin": {
    "includes": "Pełny dostęp administracyjny w Promang dla firmy: użytkownicy, role, ustawienia i wszystkie moduły włączone dla firmy.",
    "adminNote": "Nadawaj tylko zaufanym osobom. Administrator widzi wrażliwe dane firmy i może zmieniać dostępy wszystkich innych. Włączaj tylko moduły, z których firma faktycznie korzysta."
  },
  "phone": {
    "includes": "Dostęp do telefonii/komunikacji z klientami, gdy skonfigurowano Phonero lub podobną usługę.",
    "adminNote": "Wymaga prawidłowych danych logowania integracji w firmie. Ogranicz do osób obsługujących połączenia przychodzące/wychodzące."
  },
  "phone_control-panel": {
    "includes": "Korzystanie z centrali/panelu sterowania do obsługi połączeń i kolejek.",
    "adminNote": "Łącz z modułem telefonii i szkoleniem z procedur przekierowania i rejestrowania połączeń."
  },
  "phone_settings": {
    "includes": "Może zmieniać ustawienia telefonii dla firmy.",
    "adminNote": "Błędne ustawienia mogą zablokować połączenia lub pogorszyć obsługę klienta. Tę rolę powinno mieć niewiele osób."
  },
  "calendar": {
    "includes": "Przeglądanie i używanie kalendarza firmy (wizyty, uczestnicy, własny udział).",
    "adminNote": "Kalendarz może ujawniać aktywność klientów i projektów. Oceń, kto potrzebuje pełnego przeglądu kalendarza."
  },
  "customers": {
    "includes": "Praca z kartotekami klientów: kontakty, adresy, umowy i powiązane dane podstawowe.",
    "adminNote": "Dane klientów często podlegają ochronie danych osobowych. Nadawaj tylko sprzedaży, serwisowi i kierownictwu, które ich potrzebują w pracy."
  },
  "customer-handler": {
    "includes": "Wykonywanie zadań obsługi klienta w Promang (działania następcze, rejestracja).",
    "adminNote": "Ustal zakres względem roli «customers», aby nie wszyscy dostawali pełną edycję bez potrzeby."
  },
  "customer_settings": {
    "includes": "Zmiana ustawień modułu klientów (pola, procedury, dostosowania).",
    "adminNote": "Zmiany obowiązują w całej firmie. Przetestuj w środowisku testowym lub na ograniczonej grupie przed szerokim wdrożeniem."
  },
  "contacts": {
    "includes": "Dostęp do kontaktów powiązanych z klientami lub projektami.",
    "adminNote": "Kontakty zawierają dane osobowe – przestrzegaj RODO i wewnętrznych zasad, kto może eksportować/tworzyć wyciągi."
  },
  "projects": {
    "includes": "Przeglądanie projektów, folderów, uczestników i podstawowych informacji o projekcie.",
    "adminNote": "Łącz z «projects_edit» lub rolami projektowymi, gdy użytkownik ma zmieniać strukturę i finanse."
  },
  "projects_edit": {
    "includes": "Edycja projektów (nazwa, status, finanse tam, gdzie system pozwala).",
    "adminNote": "Unikaj sytuacji, w której zbyt wiele osób może zmieniać budżet i kluczowe dane – wzoruj się na kierowniku projektu."
  },
  "projects_create": {
    "includes": "Tworzenie nowych projektów.",
    "adminNote": "Upewnij się, że szablony i numeracja projektów są uzgodnione, aby nowe projekty były jednolite."
  },
  "projects_plan": {
    "includes": "Plan projektu (oś czasu), zdarzenia projektu i API planu — dla projektów, w których uczestniczysz. Widoczne w menu «Projekty» bez pełnej roli «projects».",
    "adminNote": "Wymaga udziału w projekcie (project access). Nie daje dostępu do zleceń pracy, folderów ani ogólnej edycji projektu — w razie potrzeby nadaj «projects» / «projects_edit»."
  },
  "projects_accounting": {
    "includes": "Faktury, faktury dostawców, plan fakturowania i podsumowanie w projektach, w których uczestniczysz (osobna zakładka na stronie projektu).",
    "adminNote": "Wymaga udziału w projekcie. Przyciski edycji w tych zakładkach wymagają dodatkowo uprawnienia do edycji projektu (lub administratora); w przeciwnym razie dane są tylko do odczytu."
  },
  "project_settings": {
    "includes": "Zmiana ustawień modułu projektów dla firmy.",
    "adminNote": "Dotyczy wszystkich projektów. Ogranicz do administratora lub kierownictwa projektów."
  },
  "projects_work-orders": {
    "includes": "Przeglądanie zleceń pracy, w które użytkownik jest zaangażowany (uczestnik/rola).",
    "adminNote": "Do edycji i drukowania często potrzebna jest rola «projects_work-orders_edit». Sprawdź, czy właściwe osoby są ustawione jako uczestnicy."
  },
  "projects_work-orders_edit": {
    "includes": "Edycja i drukowanie zleceń pracy, w których użytkownik jest uczestnikiem.",
    "adminNote": "Zlecenia pracy mogą zawierać ceny i dane klientów – ogranicz do personelu fachowego."
  },
  "projects_work-orders_create": {
    "includes": "Tworzenie nowych zleceń pracy w projektach, do których użytkownik ma dostęp.",
    "adminNote": "Ustal, kto może tworzyć nowe zlecenia pracy, w odniesieniu do procedur fakturowania i zatwierdzania."
  },
  "hours": {
    "includes": "Rejestrowanie i przeglądanie własnych godzin (oraz ewentualnie godzin innych, jeśli rola na to pozwala).",
    "adminNote": "Łącz z «hours_approval» lub «edit_hours» do zatwierdzania i pełnej edycji. Ustal jasne terminy zatwierdzania."
  },
  "hours_register": {
    "includes": "Rejestrowanie własnych nieobecności/urlopów, gdy moduł nieobecności jest aktywny.",
    "adminNote": "Ustal widoczność dla przełożonego/działu płac. Zadbaj o prawidłowe typy nieobecności w konfiguracji."
  },
  "hours_approval": {
    "includes": "Przeglądanie godzin wymagających działań w procesie zatwierdzania (zgodnie z regułami modułu).",
    "adminNote": "Wynagrodzenia i fakturowanie często opierają się na zatwierdzonych godzinach. Rozdziel zatwierdzających i zaplanuj zastępstwa na czas urlopów."
  },
  "hours_overview": {
    "includes": "Przegląd godzin dla całej firmy (wszystkie projekty w okresie) z filtrami aktywności, projektu, pracowników i działu oraz szacowanym kosztem i sprzedażą.",
    "adminNote": "Wymaga dodatkowo rejestracji czasu pracy (hours). Sama nie daje zatwierdzania ani fakturowania. Nie tylko dla administratora."
  },
  "hours_monthly_overview": {
    "includes": "Miesięczny przegląd godzin dla osoby odpowiedzialnej za godziny w firmie («hours handler»).",
    "adminNote": "Powiązane z polem osoby odpowiedzialnej za godziny w firmie – sprawdź, czy wybrano właściwą osobę."
  },
  "hour_settings": {
    "includes": "Zmiana ustawień godzin (kody, reguły, integracje z systemem płacowym).",
    "adminNote": "Błędna konfiguracja daje błędną podstawę wynagrodzeń. Ogranicz do HR/działu płac i administratora."
  },
  "edit_hours": {
    "includes": "Edycja godzin innych osób (eksport, korekty), gdy moduł godzin jest aktywny.",
    "adminNote": "Silny dostęp do danych płacowych. Dokumentuj procedury i ogranicz do kilku zaufanych superużytkowników."
  },
  "service": {
    "includes": "Serwis i zlecenia: klienci, raporty, dokumenty, SMS/powiadomienia zgodnie z dostępami.",
    "adminNote": "Często szeroka rola. Uzupełnij bardziej szczegółowymi rolami (umowy, raporty), jeśli chcesz ograniczyć to, co widzą pracownicy terenowi."
  },
  "service_reports": {
    "includes": "Tworzenie, aktualizowanie i obsługa raportów serwisowych.",
    "adminNote": "Raporty mogą zawierać dane klientów i zdjęcia – przestrzegaj zasad przechowywania danych i zdjęć."
  },
  "service_agreements": {
    "includes": "Praca z umowami serwisowymi i powiązanymi harmonogramami.",
    "adminNote": "Umowy wiążą finanse i zobowiązania – krąg osób mogących zmieniać ceny i warunki powinien być ograniczony."
  },
  "service_settings": {
    "includes": "Zmiana ustawień serwisu (szablony, pola, procesy).",
    "adminNote": "Dotyczy wszystkich użytkowników raportujących serwis. Wprowadzaj zmiany w porozumieniu z osobą odpowiedzialną za jakość."
  },
  "quality": {
    "includes": "Treści BHP/jakości: dokumenty, procedury, schemat organizacyjny, chemikalia itp. (w ramach włączonego modułu «quality»).",
    "adminNote": "Wiele funkcji podlega audytom i odpowiedzialności. Role typu «manage» nadawaj kierownikowi ds. jakości/koordynatorowi BHP."
  },
  "quality_checklists": {
    "includes": "Listy kontrolne: wykonywanie, obsługa i zamykanie punktów kontrolnych.",
    "adminNote": "Upewnij się, że ustawiono odpowiedzialnego wykonawcę, a niezgodności w razie potrzeby są zgłaszane w module niezgodności."
  },
  "quality_deviations": {
    "includes": "Rejestrowanie i obsługa niezgodności oraz działań.",
    "adminNote": "Niezgodności mogą być wrażliwe. Ogranicz, kto może zamykać lub usuwać niezgodności."
  },
  "quality_settings": {
    "includes": "Zmiana ustawień dokumentów BHP/jakości i powiązanych typów.",
    "adminNote": "Zmiany wpływają na klasyfikację i zatwierdzanie. Tylko osoba odpowiedzialna za BHP/jakość lub administrator."
  },
  "hse": {
    "includes": "Dostęp do odczytu wybranych dokumentów i procedur BHP (starsza/uproszczona rola BHP).",
    "adminNote": "Łącz z «quality», gdy potrzebny jest szerszy dostęp do dokumentów."
  },
  "hse_qualities": {
    "includes": "Praca z celami/wpisami jakościowymi w części BHP/jakość.",
    "adminNote": "Ustal, kto odpowiada za aktualizacje na potrzeby audytu i przeglądu zarządzania."
  },
  "hse_instructions": {
    "includes": "Dostęp do instrukcji stanowiskowych i procedur.",
    "adminNote": "Instrukcje muszą być w aktualnej wersji – ogranicz, kto może publikować zmiany."
  },
  "hse_qualities_manage": {
    "includes": "Tworzenie, zmiana i zarządzanie wpisami jakościowymi.",
    "adminNote": "Silna rola wpływająca na ślad audytowy – tylko osoba odpowiedzialna za BHP/jakość lub wyznaczona osoba."
  },
  "hse_instructions_manage": {
    "includes": "Publikowanie instrukcji stanowiskowych i zarządzanie nimi.",
    "adminNote": "Błędna instrukcja może prowadzić do naruszeń BHP. Korzystaj z procesu zatwierdzania i wersjonowania."
  },
  "chemical_inventory": {
    "includes": "Rejestr substancji chemicznych: substancje, poziomy BHP i powiązana dokumentacja.",
    "adminNote": "Wymaga wiedzy fachowej (karty charakterystyki). Aktualizuj przy zakupach i wycofywaniu substancji."
  },
  "hse_ks": {
    "includes": "Moduł BHP/jakość: zdarzenia, ryzyko, dokumenty, kompetencje i ocena (zależnie od aktywnych podmodułów).",
    "adminNote": "Moduł jest często istotny dla ISO. Wyznacz właścicieli dokumentów, ryzyka i mapy kompetencji – oraz ustal, kto otrzymuje role «manage»."
  },
  "hse_ks_events": {
    "includes": "Rejestrowanie i obsługa zdarzeń BHP (zdarzenia potencjalnie wypadkowe, niezgodności, obserwacje).",
    "adminNote": "Upewnij się, że stopnie powagi i eskalacja są uzgodnione z kierownictwem."
  },
  "hse_ks_risk": {
    "includes": "Oceny ryzyka i rejestr ryzyka.",
    "adminNote": "Ryzyko trzeba aktualizować przy zmianie procesów. Unikaj ocen „widmo” bez właściciela."
  },
  "hse_ks_documents": {
    "includes": "Odczyt i używanie dokumentów BHP/jakości oraz ich rewizji.",
    "adminNote": "Czytelnicy nie powinni automatycznie otrzymywać prawa zatwierdzania – wydziel rolę «approve»."
  },
  "hse_ks_documents_approve": {
    "includes": "Zatwierdzanie dokumentów i rewizji w procesie BHP/jakości.",
    "adminNote": "Tylko osoby z uprawnieniami merytorycznymi. Dokumentuj, kto co zatwierdza (odpowiedzialność/kompetencje)."
  },
  "hse_ks_competency": {
    "includes": "Przeglądanie wymagań kompetencyjnych, szkoleń i działań dla ról.",
    "adminNote": "Historia szkoleń zawiera dane osobowe – przestrzegaj ochrony danych i ograniczeń wglądu."
  },
  "hse_ks_competency_manage": {
    "includes": "Zarządzanie matrycą kompetencji, rolami i wymaganiami.",
    "adminNote": "Zmiany wpływają na to, kto może wykonywać pracę. Koordynuj z HR i społecznym inspektorem pracy."
  },
  "hse_ks_evaluation": {
    "includes": "Obchody BHP, oceny i punkty do realizacji w BHP/jakości.",
    "adminNote": "Wyniki mogą wymagać działań – wyznacz osobę odpowiedzialną za realizację w terminie."
  },
  "hse_ks_settings": {
    "includes": "Zmiana ustawień modułu BHP/jakość.",
    "adminNote": "Tylko administrator lub kierownik BHP/jakości. Błędne pola wpływają na raportowanie do kierownictwa."
  },
  "products": {
    "includes": "Katalog produktów: artykuły, ceny, widoki magazynowe tam, gdzie moduł pozwala.",
    "adminNote": "Zmiany cen przenoszą się na oferty i zamówienia – ogranicz do działu zakupów/sprzedaży."
  },
  "product_settings": {
    "includes": "Zmiana ustawień i struktur produktów.",
    "adminNote": "Dotyczy całego łańcucha sprzedaży. Przetestuj zmiany przed wdrożeniem produkcyjnym."
  },
  "orders": {
    "includes": "Obsługa zamówień: tworzenie, zmiana statusu i śledzenie pozycji zamówienia.",
    "adminNote": "Zamówienia wiążą magazyn i fakturę. Ustal, kto może anulować lub zmieniać cenę."
  },
  "order_settings": {
    "includes": "Zmiana ustawień zamówień i sprzedaży.",
    "adminNote": "Tylko kilku użytkowników. Błędne ustawienia powodują błędny VAT i problemy z integracjami."
  },
  "offers": {
    "includes": "Oferty: przygotowywanie, wysyłanie i obsługa ofert dla klientów.",
    "adminNote": "Oferty mogą wiązać cenę – ustal limity rabatów i zatwierdzanie odstępstw."
  },
  "offers_settings": {
    "includes": "Zmiana ustawień i szablonów ofert.",
    "adminNote": "Zmiany szablonów dotyczą wszystkich handlowców – wersjonuj i informuj przed aktywacją."
  },
  "inventory": {
    "includes": "Magazyn: stan, lokalizacje, przesunięcia w ramach modułu.",
    "adminNote": "Stan fizyczny i systemowy muszą się zgadzać – regularnie przeprowadzaj inwentaryzacje i uzgodnienia."
  },
  "inventory_settings": {
    "includes": "Zmiana konfiguracji magazynu (lokalizacje, integracje, reguły).",
    "adminNote": "Błędna lokalizacja powoduje błędy kompletacji. Dokumentuj zmiany dla zespołu operacyjnego."
  },
  "inventory_finance": {
    "includes": "Przeglądanie cen kosztowych, wartości magazynu i raportów okresowych magazynu.",
    "adminNote": "Daje wgląd w finansowe dane magazynowe. Nadawaj tylko pracownikom, którzy wykonują uzgodnienia."
  },
  "counts": {
    "includes": "Arkusze spisowe i inwentaryzacja w magazynie.",
    "adminNote": "Inwentaryzacja wpływa na zaksięgowany stan – zaplanuj datę odcięcia i odpowiedzialnego za liczenie."
  },
  "cases": {
    "includes": "Przeglądanie wszystkich spraw w firmie. Bez tej roli nadal możesz otwierać sprawy, w których jesteś wykonawcą lub o których wspomniano.",
    "adminNote": "Nadawaj osobom, które potrzebują przeglądu. Tworzenie, pisanie i edycja to osobne role."
  },
  "cases_create": {
    "includes": "Tworzenie nowych spraw.",
    "adminNote": "Nie daje automatycznie listy wszystkich spraw."
  },
  "cases_write": {
    "includes": "Dodawanie aktualizacji do spraw, które możesz czytać.",
    "adminNote": "Wymaga, aby sprawa była widoczna (wszystkie sprawy, wykonawca lub wzmianka)."
  },
  "cases_edit": {
    "includes": "Edycja pól sprawy, przekazywanie i usuwanie. Obejmuje też pisanie i czytanie wszystkich spraw.",
    "adminNote": "Silne uprawnienie – ogranicz do osób odpowiedzialnych za sprawy."
  },
  "driving": {
    "includes": "Bez «driving_trips»: cała flota (wszystkie przejazdy, wszystkie pojazdy w API, menu Kierowcy razem z «driving_drivers»). Razem z «driving_trips»: rola nadrzędna dla menu Przejazdy, ale jesteś **kierowcą** — tylko własne przejazdy i zalogowany pojazd, bez pełnej listy **Pojazdy**.",
    "adminNote": "Sam kierownik floty: «driving» bez «driving_trips». Kierowca, który potrzebuje menu modułu: «driving» + «driving_trips»; pełna flota wymaga «driving_vehicles» lub usunięcia «driving_trips»."
  },
  "driving_trips": {
    "includes": "Własne przejazdy, zalogowany pojazd i link do podręcznika. Razem z «driving» (bez «driving_vehicles») nadal jesteś **kierowcą** — nie widzisz wszystkich przejazdów firmy ani listy **Pojazdy**.",
    "adminNote": "Wymaga wpisu kierowcy (Driver). Pełna flota: «driving» bez tej roli albo «driving_drivers» / «driving_vehicles» w zależności od potrzeb."
  },
  "driving_drivers": {
    "includes": "Pozycja menu Kierowcy i **wszystkie** przejazdy firmy w API (razem z administratorem) do nadzoru; pełna lista **Pojazdy** w aplikacji.",
    "adminNote": "Prawo jazdy i dane o zdrowiu – ogranicz wgląd. Sam kierowca bez floty: «driving» + «driving_trips» (ewent. «vehicles»), bez «driving_drivers» i bez «driving_vehicles»."
  },
  "driving_vehicles": {
    "includes": "Wszystkie pojazdy firmy (lista, szczegóły, przegląd techniczny, dokumenty, podręcznik). Można nadać bez «driving»; nie daje dostępu do wszystkich przejazdów firmy (tylko «driving»/administrator/rejestr kierowców).",
    "adminNote": "W połączeniu wyłącznie z «driving_trips»: pełna lista pojazdów, ale przejazdy nadal są filtrowane do własnych przejazdów kierowcy."
  },
  "vehicles": {
    "includes": "Starsza rola pomocnicza dla menu; w API sama nie daje pełnej listy pojazdów — tak samo jak kierowca: zalogowany pojazd, gdy istnieje wpis kierowcy. Pełna flota: «driving_vehicles» lub «driving»/rejestr kierowców.",
    "adminNote": "Nie używaj «vehicles» zamiast «driving_vehicles», gdy użytkownik ma widzieć całą flotę."
  },
  "tools": {
    "includes": "Moduł narzędzi: sprzęt monitorowany w eksploatacji.",
    "adminNote": "Wyznacz osobę odpowiedzialną za kontrolę i nadzór narzędzi wymagających dokumentacji."
  },
  "resource_hub": {
    "includes": "Centrum zasobów: szkolenia, FAQ i wspólne materiały pomocnicze.",
    "adminNote": "Dbaj o aktualność treści – nieaktualne artykuły generują zbędne zgłoszenia do wsparcia."
  },
  "faq": {
    "includes": "Zarządzanie FAQ i artykułami pomocy w centrum zasobów.",
    "adminNote": "Zmiany są widoczne dla wszystkich – ważny jest poprawny język i działające linki."
  },
  "templates": {
    "includes": "Szablony dokumentów i teksty standardowe używane w Promang.",
    "adminNote": "Błędy w szablonach dotykają wielu użytkowników – najpierw przetestuj na jednej grupie."
  },
  "website": {
    "includes": "Strony firmowe lub strony docelowe hostowane/połączone przez Promang.",
    "adminNote": "Opublikowane treści są publiczne – zatwierdź tekst i zdjęcia przed publikacją."
  },
  "webpage": {
    "includes": "Edycja pojedynczych stron w module strony internetowej.",
    "adminNote": "SEO, ochrona danych i dostępność – stosuj szablon i weryfikację prawną."
  },
  "absences": {
    "includes": "Przegląd nieobecności zespołu dla przełożonego (zgodnie z regułami modułu).",
    "adminNote": "Dane o nieobecnościach są wrażliwe – ogranicz do przełożonych z uzasadnioną potrzebą."
  },
  "absence": {
    "includes": "Uproszczony dostęp do nieobecności (często tylko własne lub ograniczony przegląd).",
    "adminNote": "Ustal zakres względem «absences» i «hours_register»."
  },
  "absence_settings": {
    "includes": "Zmiana typów nieobecności, limitów i reguł.",
    "adminNote": "Błędny typ daje błędne wynagrodzenie/urlop – tylko HR lub administrator."
  },
  "meeting_minutes": {
    "includes": "Protokoły ze spotkań: tworzenie, udostępnianie i archiwizowanie notatek.",
    "adminNote": "Mogą zawierać decyzje o znaczeniu prawnym – zablokuj wersję po podpisaniu."
  },
  "meeting_minutes_templates": {
    "includes": "Zarządzanie szablonami protokołów ze spotkań.",
    "adminNote": "Zmiany szablonów dotyczą wszystkich spotkań – wersjonuj i informuj protokolantów."
  },
  "drawings": {
    "includes": "Rysunki i dokumentacja techniczna powiązana z projektami.",
    "adminNote": "Często chronione prawami własności intelektualnej – ogranicz pobieranie i udostępnianie zewnętrzne."
  },
  "accounting": {
    "includes": "Funkcje księgowe i eksport (tam, gdzie moduł jest dostępny).",
    "adminNote": "Silny dostęp do danych finansowych. Zwykle tylko administrator w Promang."
  },
  "payslips": {
    "includes": "Przeglądanie i pobieranie własnych pasków wynagrodzenia z Tripletex (Moje paski wynagrodzenia).",
    "adminNote": "Nie daje wglądu w paski wynagrodzenia ani podstawę wynagrodzeń innych osób. Do administrowania w firmie potrzebny jest administrator firmy oraz «payslips_admin» (Wynagrodzenia – admin)."
  },
  "payslips_admin": {
    "includes": "Wszystkie paski wynagrodzenia w firmie, ręczna synchronizacja z Tripletex, PDF innych pracowników i podstawa wynagrodzeń. Działa tylko razem z rolą administratora firmy.",
    "adminNote": "Nadawaj jawnie. Administrator firmy bez tej roli widzi tylko własne paski wynagrodzenia. Wynagrodzenia – admin bez roli administratora nie daje administrowania firmą."
  },
  "microsoft_personal_mail_ai": {
    "includes": "Zezwolenie na funkcje AI dla osobistej poczty Microsoft (tam, gdzie włączone).",
    "adminNote": "Wymaga wyraźnej zgody i zasad – nie włączaj dla wszystkich bez oceny."
  },
  "tasks": {
    "includes": "Zadania: wykonywanie i zamykanie przydzielonych zadań.",
    "adminNote": "Starszy/równoległy moduł zadań – sprawdź, czy role projektowe lub spraw pokrywają potrzebę."
  },
  "checklists": {
    "includes": "Starszy dostęp do list kontrolnych (często powiązany z modułem jakości).",
    "adminNote": "Dla nowych konfiguracji rozważ «quality_checklists» jako rolę główną."
  },
  "items": {
    "includes": "Pozycje materiałowe i zużycie powiązane z projektem/zamówieniem (starsza rola).",
    "adminNote": "W nowych instalacjach ustal zakres względem «products» i «inventory»."
  },
  "item_consumption": {
    "includes": "Rejestrowanie zużycia materiałów w zleceniach.",
    "adminNote": "Wpływa na koszty i magazyn – zadbaj o prawidłowe ceny kosztowe i wytyczne."
  },
  "sales": {
    "includes": "Rola sprzedażowa (zarezerwowana/rozszerzenie w niektórych instalacjach).",
    "adminNote": "Ustal z administratorem, co jest włączone w waszym środowisku."
  },
  "edit_projects": {
    "includes": "Starsza nazwa roli edycji projektów (często odpowiada «projects_edit»).",
    "adminNote": "Rozważ ujednolicenie na nowe nazwy ról w administracji użytkownikami."
  },
  "users": {
    "includes": "Zarządzanie użytkownikami i dostępami w firmie (bez pełnych uprawnień administratora).",
    "adminNote": "Nie nadawaj osobom z zewnątrz bez umowy. Dokumentuj zmiany ról na potrzeby audytu."
  },
  "company": {
    "includes": "Ustawienia firmy, takie jak logo, adres i podstawowy profil.",
    "adminNote": "Zmiany mogą wpływać na nagłówek faktury i widok klienta – edytować powinno niewiele osób."
  }
};
